<template>
	<div class="members">
		<img alt="logo" v-if="this.$store.state.logo == 'bd'" src="../assets/bdlogo-color.png" class="login-logo" />
		<img alt="logo" v-if="this.$store.state.logo == 'tbs'" src="../assets/tbs-logo.jpg" class="login-tbs-logo" />
		<img alt="logo" v-if="this.$store.state.logo == 'nrm'" src="../assets/nrm-logo.png" class="login-logo" />

		<h3>Members</h3>
		<div class="button-wrapper" v-if="page == null">
			<div class="member-button" @click="buttonClicked('create')">Add New Member</div>
			<div class="member-button" @click="buttonClicked('search')">Search Members</div>
			<div class="member-button" @click="buttonClicked('rewards')">Member Rewards</div>
		</div>

		<div v-if="page != null && page == 'rewards'">
			<memberRewards />
		</div>

		<div v-if="page != null && page == 'create'">
			<memberCreate />
		</div>

		<div v-if="page != null && page == 'search'">
			<memberSearch />
		</div>

		<div v-if="page !== null">
			<div class="member-back-button" @click="buttonClicked()">Back</div>
		</div>
	</div>
</template>

<script>
import memberRewards from '@/components/memberRewards.vue'
import memberCreate from '@/components/memberCreate.vue'
import memberSearch from '@/components/memberSearch.vue'

export default {
	name: 'settings',

	data: function() {
		return {
			page: null
		}
	},

	components: {
		memberRewards,
		memberCreate,
		memberSearch
	},

	watch: {},

	mounted: async function() {},

	methods: {
		buttonClicked: function(value = null) {
			if (value !== null) {
				this.page = value
			} else {
				this.page = null
			}
		}
	}
}
</script>

<style scoped>
.members {
	padding: 20px;
	margin: auto;
	font-size: 13px;
	font-family: 'poppinssemibold';
	color: #000;
}

h3 {
	font-size: 25px;
	margin-bottom: 1em;
}

.button-wrapper {
	width: 600px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	margin: 20px auto;
}

.member-button {
	margin: auto;
	padding-top: 70px;
	width: 150px;
	height: 150px;
	background-color: #62c7c2;
	color: #fff;
	border-radius: 5px;
	cursor: pointer;
}

.member-back-button {
	margin: 5em auto;
	padding-top: 15px;
	width: 150px;
	height: 50px;
	background-color: #ff4343;
	color: #fff;
	border-radius: 5px;
}

img.login-logo {
	width: 20%;
}

img.login-tbs-logo {
	width: 15%;
}
</style>
